/**
 * xp-fraction.ts — XP earned of a total, written the one way every student
 * screen says it: "20 / 530 XP". The campaign hero said "0 / 530" and the
 * campaign page's chapter rows "0/255 XP" while the rest said "0 / 530 XP";
 * written once, the screens cannot drift apart again.
 */

/** XP earned of a total: "20 / 530 XP". */
export const xpFraction = (earned: number, total: number): string => `${earned} / ${total} XP`;
